import { createSlice } from '@reduxjs/toolkit';

const lockScreenSlice = createSlice({
  name: 'lockScreen',
  initialState: {
    isLockScreenVisible: false,
    inactivityTimeoutId: null,
  },
  reducers: {
    showLockScreen: (state) => {
      state.isLockScreenVisible = true;
    },
    hideLockScreen: (state) => {
      state.isLockScreenVisible = false;
    },
    setInactivityTimeout: (state, action) => {
      state.inactivityTimeoutId = action.payload;
    },
    clearInactivityTimeout: (state) => {
      if (state.inactivityTimeoutId) {
        clearTimeout(state.inactivityTimeoutId);
        state.inactivityTimeoutId = null;
      }
    },
  },
});

export const { showLockScreen, hideLockScreen, setInactivityTimeout, clearInactivityTimeout } = lockScreenSlice.actions;
export default lockScreenSlice.reducer;
